const getDataFromStorage = (persistName: string, value = "") => {
    return window?.localStorage?.getItem(`persist:${persistName}`) != null ? JSON.parse(window.localStorage.getItem(`persist:${persistName}`) || "{}")[value] : null;
}

const setDataToStorage = (persistName: string, key: string, value: any) => {
    if (window?.localStorage?.getItem(`persist:${persistName}`) == null) window.localStorage.setItem(`persist:${persistName}`, "{}");
    const data = { ...JSON.parse(window.localStorage.getItem(`persist:${persistName}`) || "{}"), [key]: value }
    window.localStorage.setItem(`persist:${persistName}`, JSON.stringify(data) || "");
}

export {
    getDataFromStorage,
    setDataToStorage
}